import React, {Component} from 'react';
import {connect} from 'react-redux';
import {MdAddCircleOutline} from "react-icons/md";
import {AiOutlineDelete} from "react-icons/ai";
import { toastMessage } from '../utils/toast';
import Loader from "react-loader-spinner";
import * as formActions from '../../Redux/Actions/form';
import * as userAuthActions from '../../Redux/Actions/user';
import Header from '../Ui/Header';
import { types, fieldTemplates, langOptions, defaultFields } from './types';
import {Input} from '../Ui/Input';
import Checkbox from '../Ui/Checkbox';
import {Button} from '../Ui/Button';
import { ContainerOuter, Container, FormContainer, FieldsContainer, TypesContainer, Type, ClickedFieldContainer, AddedFieldsContainer } from './styles';
import DropDown from '../Ui/DropDown';
import AddedFields from './addedFields';
import CreateServiceCard from './ServiceCard/createServiceCard';
import ReOrderServiceCards from './ServiceCard/reOrderServiceCard';
import Warning from '../Ui/400';
import TimeLine from './timeline';
import MetaData from './metaData';
import WorkflowActions from './workflow';
import Preview from './preview';
import CONFIG from '../../config';

class CreateFrom extends Component{

    state = {
        activeTimeLine: 'title',
        inputAction: 'add',
        type: '',
        options: [],
        actionID: '',
        lang: {label: 'English', value: 'en'},
        actionLabel: '',
        actionName: '',
        arabicActionName: '',
        arabicActionLabel: '',
        optionnameEnglish: '',
        optionnameArabic: '',
        loading: false,
        editFieldID: null,
        clearData: false,
        categoryName: '',
        categoryArabicName: '',
        newCategory: false,
        errStatus: 200
    };

    componentDidMount(){
        // this.setupBeforeUnloadListener();
    }

    setupBeforeUnloadListener = () => {
        window.addEventListener("beforeunload", (ev) => {
            ev.preventDefault();
            return this.doSomethingBeforeUnload();
        });
    };

    doSomethingBeforeUnload = () => {
        this.setState({clearData: true});
    }

    componentWillUnmount(){
        const {formMetaData, reArrangeFieldData, createWorkflowAction, serviceCardData, editServiceCard, createCategory} = this.props;
        formMetaData({});
        reArrangeFieldData([]);
        createWorkflowAction({});
        serviceCardData([]);
        editServiceCard({});
        createCategory({});
    }

    componentDidUpdate(prevProps, prevState){
        const {type, inputAction} = this.state;
        if(type !== prevState.type){
            if(inputAction === 'add'){
                this.setState({
                    method: '', englishlabel: '', arabiclabel: '', name: '', characterlength: '', englishplaceholder: '', arabicplaceholder: '', required: false, multiple: false, encrypt: false, 
                    dynamic: false, optionnameEnglish: '', optionnameArabic: '', options: [], documentvault: false, categoryName: '', categoryArabicName: ''
                });
            }
        }
    }

    handleOkClear = () => {
        this.setState({
            clearData: false
        });
        const { formMetaData, reArrangeFieldData, createWorkflowAction, history } = this.props;
        formMetaData({});
        reArrangeFieldData([]);
        createWorkflowAction({});
        history.push('/dashboard');
    }

    handleCancelClear = () => {this.setState({clearData: false})}

    handleInputChange = (key, value) => {
        this.setState({
            [key]: value
        });
    }

    handleMetaData = () => {
        const { title, description, arabictitle, arabicdescription } = this.state;
        const { formMetaData } = this.props;
        (((title === '') || (description === '')) && ((arabictitle === '') || (arabicdescription === ''))) ? this.handleToastNotify('error', 'Type the form title and description') : formMetaData({title, description, arabictitle, arabicdescription});
        this.setState({
            title: '', description: '', arabictitle: '', arabicdescription: ''
        });
    }

    handleInputOptions = () => {
        let {optionnameEnglish, optionnameArabic, options} = this.state;
        let newOption = {value: optionnameEnglish.replace(/ /g, '').toLowerCase(), label: optionnameEnglish, arabicLabel: optionnameArabic};
        ((optionnameEnglish === '') || (optionnameArabic === '')) ? this.handleToastNotify('error', "Can't add empty option") : options = (options.length > 0) ? [...options, newOption] : [newOption];
        this.setState({
            options,
            optionnameEnglish: '',
            optionnameArabic: ''
        });
    }

    handleRemoveOption = (label, id) => {
        let {options} = this.state;
        options = options.filter((option, index) => index !== id);
        this.setState({options})
    }

    getFieldValues = (fieldTypes, type, inputAction) => {
        const { editFieldID } = this.state;
        const { formData, addFieldData, editFieldData } = this.props;
        let newArr = [];
        fieldTypes.map(({fields}) =>
            newArr = newArr.concat(fields)
        );
        newArr = newArr.map(field => field.replace(/ /g, '').toLowerCase());

        let newObj = {type};
        for (const field of newArr) {
            newObj = {...newObj, [field]: this.state[field]};
        }
        let optionFields = ['radio', 'dropdown'];
        let emptyCheck = (newObj.name !== '') && (optionFields.includes(type) ? (newObj.dynamic ? true : (newObj.options.length !== 0)) : true);
        if (type === 'default') {
            if (this.state['referencename'] || this.state['registeredinformation'] || this.state['adrosubmission']) {
                let existingAvailable = formData.filter(field => newObj[field.name]  === true);
                if (existingAvailable.length > 0) { 
                    this.handleToastNotify('error', "Already default field added");
                } else {
                    this.state['referencename'] && addFieldData(defaultFields.referenceNameInput);
                    if (this.state['registeredinformation']) {
                        addFieldData(defaultFields.userInfoBreakLine);
                        addFieldData(defaultFields.userInfoPhoneNumberInput);
                        addFieldData(defaultFields.userInfoEmailInput);
                        addFieldData(defaultFields.userInfoCheckbox);
                    } 
                    if(this.state['adrosubmission']) {
                        addFieldData(defaultFields.userAdroCheckbox);
                    }
                }
            } else {
                this.handleToastNotify('error', "Can't add empty field");
            } 
        } else {
            emptyCheck ? (inputAction === 'update') ? editFieldData(editFieldID, newObj) : addFieldData(newObj)
                : this.handleToastNotify('error', "Can't add empty field");
        }

        this.setState({
            type:  emptyCheck ? '' : type,
            inputAction: emptyCheck ? 'add' : inputAction
        });
    }

    handleRemoveFormField = (data) => {
        return window.confirm(`Have you want to delete ${data.name} form field ?`) ? this.props.deleteFieldData(data) : '';
    }

    handleWorkFlowAction = () => {
        const {actionID, actionLabel, actionName, arabicActionName, arabicActionLabel} = this.state;
        const {createWorkflowAction, editWorkflowAction} = this.props;
        (actionID !== '') ? editWorkflowAction(actionID, {actionLabel, actionName, arabicActionName, arabicActionLabel}) : 
            ((actionName === '') ? this.handleToastNotify('error', 'Type the action name and label') : createWorkflowAction({actionLabel, actionName, arabicActionName, arabicActionLabel}));
        this.setState({
            actionID: '', actionLabel: '', actionName: '', arabicActionName: '', arabicActionLabel: ''
        });
    }

    handleEditField = (data, id) => {
        let newArr = [];
        fieldTemplates[data.type].map(({fields}) =>
            newArr = newArr.concat(fields)
        );
        newArr = newArr.map(field => field.replace(/ /g, '').toLowerCase());
        this.setState({
            inputAction: 'update',
            editFieldID: id,
            ...data
        });
    }

    handleRemoveAction = (action, id) => {
        return window.confirm(`Have you want to delete ${action} workflow action ?`) ? this.props.deleteWorkflowAction(action, id) : '';
    }

    handleCreateForm = () => {
        if(CONFIG.create_form_status === 'true') {
            this.setState({loading: true});
            const { metaData, formData, actions, serviceCards, formMetaData, reArrangeFieldData, createWorkflowAction, createServiceCard, editServiceCard, createCategory, formID, history, userAuthLogout } = this.props;
            let payload = {
                name: metaData.title,
                description: metaData.description,
                json: JSON.stringify({
                    arabictitle: metaData.arabictitle,
                    arabicdescription: metaData.arabicdescription,
                    formFields: formData,
                    actions,
                    serviceCards
                })
            };
            payload = formID ? {id: formID, ...payload} : payload;
            let apiType = formID ? 'updateForm' : 'createForm';
            formActions[apiType](payload).then(res => {
                if(res){
                    this.handleToastNotify('success', `${metaData.title} form successfully ${formID ? 'updated' : 'created'}`);
                    formMetaData({});
                    reArrangeFieldData([]);
                    createWorkflowAction({});
                    createServiceCard([]);
                    createCategory({});
                    editServiceCard({});
                    setTimeout(() => {history.push('/dashboard')}, 2000);
                }else{
                    this.handleToastNotify('error', 'Try again after sometime');
                }
                this.setState({loading: false});
            }).catch(err => {
                this.setState({errStatus: err.response.status});
                if(err.response.status === 401) {
                    userAuthLogout();
                    localStorage.removeItem('jwt');
                    history.push('/');
                }
            });
        } else {
            toastMessage('error', 'Unable to create form!');
        }
        
    }

    handleSelectedFiles = (e) => {
        this.setState({
            selectedFiles: e.target.files
        });
    }

    handleToastNotify = (type, msg) => {
        toastMessage(type, msg);
    }

    render(){
        const { activeTimeLine, errStatus, metaType, inputAction, type, options, optionnameEnglish, optionnameArabic, actionID, actionLabel, actionName, arabicActionName, arabicActionLabel, loading, selectedFiles, categoryName, categoryArabicName, newCategory, multiple, lang } = this.state;
        const { history, metaData, formData, actions, reArrangeFieldData, formID, serviceCards, categories, createCategory, deleteCategory } = this.props;
        const isArabic = (lang.value === 'ar');

        if(errStatus === 400){
            return <Warning history={history} />;
        }

        return(
            <>
                <ContainerOuter>
                    <Header history={history} />
                    <Container>
                        <h2 style={{textAlign: 'center'}}>{formID ? 'Edit' : 'Create'} Form</h2>
                        <div style={{ width: '10%', margin: '0 50px 0 auto' }}>
                            <DropDown options={langOptions} inline={true} value={lang} onChange={(value) => this.handleInputChange('lang', value)} />
                        </div>
                        <TimeLine activeTimeLine={activeTimeLine} handleActiveTimeLine={value => this.setState({activeTimeLine: value})} />
                        {(activeTimeLine === 'title') && <MetaData state={this.state} handleMetaData={this.handleMetaData} handleChange={this.handleInputChange} metaType={metaType} metaData={metaData} handleEditMetaData={(title, description, arabictitle, arabicdescription, type) => this.setState({title, description, arabictitle, arabicdescription, metaType: type})} />}
                        {(activeTimeLine === 'body') && <FormContainer>
                            <FieldsContainer>
                                <TypesContainer>
                                    <h4 style={{color: '#333', margin: '15px 0'}}>Select Type</h4>
                                    <div style={{display: 'flex', flexWrap: 'wrap'}}>
                                        {types.map(inputType => <Type key={inputType} selected={type === inputType.toLowerCase()} onClick={() => this.setState({type: inputType.toLowerCase(), inputAction: 'add'})}>{inputType}</Type>)}
                                    </div>
                                </TypesContainer>
                                <ClickedFieldContainer>
                                    {fieldTemplates[type] ? <> 
                                            {fieldTemplates[type].map(({type: inputType, fields, fieldOptions}, index) => (
                                                <div key={index}>
                                                    {(inputType === 'input') ? fields.map((name, index) => ((multiple || name !== 'Limit') && <Input method={(name.replace(/ /g, '').toLowerCase() === 'characterlength') ? 'number' : 'text'} key={index} value={this.state[name.replace(/ /g, '').toLowerCase()]} name={name} label={name} inline={true} onChange={e => this.handleInputChange(name.replace(/ /g, '').toLowerCase(), e.target.value)} />))
                                                    : (inputType === 'method') ? <DropDown label={'Type'} options={fieldOptions} inline={true} value={{label: this.state[inputType], value: this.state[inputType]}} onChange={(value) => this.handleInputChange('method', value.value)} />
                                                    : (inputType === 'options') ? <div>
                                                        {fields.map((field, index) => <div key={index} style={{display: 'flex', alignItems: 'center'}}>
                                                            <div>
                                                                <Input name={field+'English'} label={field+' English'} value={optionnameEnglish} inline={true} onChange={e => this.handleInputChange(field.replace(/ /g, '').toLowerCase()+'English', e.target.value)} />
                                                                <Input name={field+'Arabic'} label={field+' Arabic'} value={optionnameArabic} inline={true} onChange={e => this.handleInputChange(field.replace(/ /g, '').toLowerCase()+'Arabic', e.target.value)} />
                                                            </div>
                                                            <div style={{marginLeft: '5px', fontSize: '24px', color: '#666', cursor: 'pointer', display: 'flex', padding: '0 5px'}} onClick={this.handleInputOptions}><MdAddCircleOutline /></div>
                                                        </div>)}
                                                       {(options && options.length !== 0) && <div style={{display: 'flex', flexDirection: 'column'}}>
                                                            <h6 className="mt-2">Options</h6>
                                                            {options.map(({value, label, arabicLabel}, index) => <p key={index} style={{margin: '5px', color: '#333'}}>{index + 1}. {label} - {arabicLabel} <AiOutlineDelete style={{margin: '0 0 0 6px', cursor: 'pointer'}} onClick={() => this.handleRemoveOption(label, index)} /></p>)}
                                                        </div>}
                                                    </div>
                                                    : (inputType === 'title') ? <div /> 
                                                    : (inputType === 'category') ? <div>
                                                            <div className="row col-md-12 p-0 m-0">
                                                                <div className="col-md-8 p-0 m-0"><DropDown label={'Category'} options={categories} value={this.state[fields[0].replace(/ /g, '').toLowerCase()]} inline={true} onChange={(value) => this.handleInputChange(fields[0].replace(/ /g, '').toLowerCase(), value)} /></div>
                                                                <div className="col-md-4 d-flex align-items-center pr-0">
                                                                    <label className="col-form-label font-weight-bold p-0">New Category</label>
                                                                    <div>
                                                                        <span className="switch switch-sm">
                                                                            <label>
                                                                                <input type="checkbox" checked={newCategory} name="dynamic category" onChange={() => this.setState({newCategory: !newCategory})} />
                                                                                <span></span>
                                                                            </label>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {newCategory && <div>
                                                                <div className="d-flex align-items-center justify-content-start">
                                                                    <div>
                                                                        <Input name={'Category'} label={'Category'} value={categoryName} inline={true} onChange={e => this.handleInputChange('categoryName', e.target.value)} />
                                                                        <Input name={'ArabicCategory'} label={'Arabic Category'} value={categoryArabicName} inline={true} onChange={e => this.handleInputChange('categoryArabicName', e.target.value)} />
                                                                    </div>
                                                                    <div style={{marginLeft: '5px', fontSize: '24px', color: '#666', cursor: 'pointer', display: 'flex', padding: '0 5px'}} onClick={() => {createCategory({label: categoryName, arabiclabel: categoryArabicName, value: categoryName}); this.setState({categoryName: '', categoryArabicName: ''})}}><MdAddCircleOutline /></div>
                                                                </div>
                                                                {(categories && categories.length !== 0) && <div style={{display: 'flex', flexDirection: 'column'}}>
                                                                    <h6 className="mt-2">Category Options</h6>
                                                                    {categories.map(({value, arabiclabel, label}, index) => <p key={index} style={{margin: '5px', color: '#333'}}>{index + 1}. {label} - {arabiclabel} <AiOutlineDelete style={{margin: '0 0 0 6px', cursor: 'pointer'}} onClick={() => deleteCategory(label, index)} /></p>)}
                                                                </div>}
                                                            </div>}
                                                        </div>
                                                    : fields.map((name, index) => <Checkbox key={index} onChange={e => this.handleInputChange(name.replace(/ /g, '').toLowerCase(), e.target.checked)} value={this.state[name.replace(/ /g, '').toLowerCase()] || false} label={name} />)}
                                                </div>
                                            ))}
                                            <Button style={{display: 'block', margin: '0 auto'}} onClick={() => this.getFieldValues(fieldTemplates[type], type, inputAction)}>{(inputAction === 'add') ? 'Add' : 'Update'}</Button>
                                        </>
                                        : <p style={{textAlign: 'center', color: '#666'}}>Select anyone of the type</p>
                                    }
                                </ClickedFieldContainer>
                            </FieldsContainer>
                            <AddedFieldsContainer>
                                <AddedFields isArabic={isArabic} formData={formData} state={this.state} handleEditField={this.handleEditField} handleRemoveFormField={this.handleRemoveFormField} reArrangeFieldData={reArrangeFieldData} handleSelectedFiles={this.handleSelectedFiles} selectedFiles={selectedFiles} />
                            </AddedFieldsContainer>
                        </FormContainer>}
                        {(activeTimeLine === 'service') && <FormContainer>
                            <FieldsContainer>
                                <CreateServiceCard />
                            </FieldsContainer>
                            <AddedFieldsContainer>
                                <ReOrderServiceCards isArabic={isArabic} />
                            </AddedFieldsContainer>
                        </FormContainer>}
                        {(activeTimeLine === 'workflow') && <WorkflowActions handleInputChange={this.handleInputChange} actionName={actionName} actionLabel={actionLabel} arabicActionName={arabicActionName} arabicActionLabel={arabicActionLabel} actionID={actionID} actions={actions} handleWorkFlowAction={this.handleWorkFlowAction} handleRemoveAction={this.handleRemoveAction} 
                            handleEditWorkflowAction={(id, waLabel, waName, waArabicName, waArabicLabel) => this.setState({ actionID: id, actionLabel: waLabel, actionName: waName, arabicActionName: waArabicName, arabicActionLabel: waArabicLabel })} />}
                        {(activeTimeLine === 'preview') && <Preview state={this.state} metaData={metaData} formData={formData} actions={actions} serviceCards={serviceCards} isArabic={isArabic} />}
                        {((actions && actions.length !== 0) && (formData.length !== 0)) && <button disabled={loading} className="btn btn-primary d-flex align-items-center mt-8" style={{margin: '0 auto'}} onClick={this.handleCreateForm}>
                            {formID ? 'Update' : 'Create'} Form {loading && <Loader type="Oval" className="ml-2" color="#00BFFF" height={20} width={20} />}
                        </button>}
                    </Container>
                </ContainerOuter>
            </>
        );
    };
};

const mapStateToProps = ({Form}) => ({
    metaData: Form.meta,
    formData: Form.data,
    actions: Form.actions,
    serviceCards: Form.serviceCards,
    categories: Form.categories
});

const mapDispatchToProps = dispatch => ({
    formMetaData: data => dispatch(formActions.formMetaData(data)),
    addFieldData: data => dispatch(formActions.addFieldData(data)),
    editFieldData: (id, data) => dispatch(formActions.editFieldData(id, data)),
    deleteFieldData: data => dispatch(formActions.deleteFieldData(data)),
    reArrangeFieldData: data => dispatch(formActions.reArrangeFieldData(data)),
    createWorkflowAction: data => dispatch(formActions.createWorkflowAction(data)),
    editWorkflowAction: (actionID, data) => dispatch(formActions.editWorkflowAction(actionID, data)),
    serviceCardData: data => dispatch(formActions.serviceCardData(data)),
    createServiceCard: data => dispatch(formActions.createServiceCard(data)),
    createCategory: data => dispatch(formActions.createCategory(data)),
    deleteCategory: (data, id) => dispatch(formActions.deleteCategory(data, id)),
    editServiceCard: data => dispatch(formActions.editServiceCard(data)),
    deleteWorkflowAction: (name, id) => dispatch(formActions.deleteWorkflowAction(name, id)),
    userAuthLogout: () => dispatch(userAuthActions.userAuthLogout())
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateFrom);